export var DocumentType;
(function (DocumentType) {
    DocumentType["ServiceRequestForm"] = "SRF";
    DocumentType["Correspondence"] = "COR";
    DocumentType["Income"] = "INC";
    DocumentType["Claim"] = "CLM";
    DocumentType["Enrollment"] = "ENR";
    DocumentType["PriorAuth"] = "PA";
    DocumentType["Other"] = "OTHER";
    DocumentType["AssignmentOfBenefits"] = "AOB";
})(DocumentType || (DocumentType = {}));
//# sourceMappingURL=DocumentType.js.map